import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  setNewWSDiscussion,
  setNewWSEventDiscussion,
  setNewWSProjectDiscussion,
  setNewWSDiscussionMsg,
} from "../../common/actions/discussions.action";

// as reference
const objMock = {
  "identifier": "{\"channel\":\"SubscribeToTractionLiveUpdates\",\"council_id\":\"98bc626f-fbef-4b63-9cc9-4f1f2bad6b06\"}",
  "message": {
    "data": [
      {
        "id": "8639174e-122a-4fce-915b-d23606bf322e",
        "type": "discussions",
        "attributes": {
          "id": "8639174e-122a-4fce-915b-d23606bf322e",
          "council_id": "9d4236c7-ecda-4d0f-b3ef-cc01109ca32a",
          "subject": "test submission",
          "public": false,
          "scope": "project_members",
          "creator_id": "103b0197-741e-4aac-a028-57c04b94591c",
          "anonymous": false,
          "team_id": null,
          "discussion_resource_type": "Project",
          "discussion_resource_id": "13cb0a45-9124-4a80-a5c8-f927af0618b3",
          "creator": {
            "user_id": "103b0197-741e-4aac-a028-57c04b94591c",
            "full_name": "Constantin Exari",
            "avatar": "https://traction-staging.s3.amazonaws.com/users/103b0197-741e-4aac-a028-57c04b94591c/key/96793769_1777244492418593_1941059088733437952_o.jpg"
          },
          "team": null,
          "discussion_users": [
            {
              "user_full_name": "Constantin Exari",
              "user_avatar": "https://traction-staging.s3.amazonaws.com/users/103b0197-741e-4aac-a028-57c04b94591c/key/96793769_1777244492418593_1941059088733437952_o.jpg",
              "user_id": "103b0197-741e-4aac-a028-57c04b94591c",
              "read": false
            }
          ],
          "company": {
            "slug": null
          },
          "discussion_resource": {
            "name": "chill"
          },
          "messages": [
            {
              "id": "f2ab51b7-a0a4-48b3-9140-a240e4d07125",
              "type": "discussion_messages",
              "attributes": {
                "discussion_id": "8639174e-122a-4fce-915b-d23606bf322e",
                "subject": null,
                "content": "<p>test test</p>",
                "sender_id": "103b0197-741e-4aac-a028-57c04b94591c",
                "replied_message_id": null,
                "message_id": "f2ab51b7-a0a4-48b3-9140-a240e4d07125",
                "sent_at": "2023-11-30T15:34:06.429+02:00",
                "discussion": {
                  "council_id": "9d4236c7-ecda-4d0f-b3ef-cc01109ca32a"
                },
                "sender": {
                  "avatar": "https://traction-staging.s3.amazonaws.com/users/103b0197-741e-4aac-a028-57c04b94591c/key/96793769_1777244492418593_1941059088733437952_o.jpg",
                  "full_name": "Constantin Exari"
                },
                "replied_message": {
                  "subject": null,
                  "content": null
                },
                "replies": []
              }
            }
          ],
          "project_id": "13cb0a45-9124-4a80-a5c8-f927af0618b3",
          "company_id": null,
          "company_slug": null,
          "event_id": null
        }
      }
    ]
  }
};
// message res
const objMockMsg = {
  "identifier": "{\"channel\":\"SubscribeToTractionLiveUpdates\",\"council_id\":\"9d4236c7-ecda-4d0f-b3ef-cc01109ca32a\"}",
  "message": {
    "data": [
      {
        "id": "ab5be42f-48b2-4293-b606-0d15c6590ea8",
        "type": "discussion_messages",
        "attributes": {
          "discussion_id": "c5218903-ec56-426e-8916-f0ee462b36bc",
          "subject": null,
          "content": "<p>3</p>",
          "sender_id": "103b0197-741e-4aac-a028-57c04b94591c",
          "replied_message_id": null,
          "message_id": "ab5be42f-48b2-4293-b606-0d15c6590ea8",
          "sent_at": "2023-12-01T14:57:43.369+02:00",
          "discussion": {
            "council_id": "9d4236c7-ecda-4d0f-b3ef-cc01109ca32a"
          },
          "sender": {
            "avatar": "https://traction-staging.s3.amazonaws.com/users/103b0197-741e-4aac-a028-57c04b94591c/key/96793769_1777244492418593_1941059088733437952_o.jpg",
            "full_name": "Constantin Exari"
          },
          "replied_message": {
            "subject": null,
            "content": null
          },
          "replies": [],
          "project_id": null,
          "company_id": null,
          "company_slug": null,
          "event_id": "f548a4b6-4e00-42a8-837e-65084d08ce17"
        }
      }
    ]
  }
};

const RootSocketProvider = ({ session, selectedCouncil }) => {
  const {
    projectsReducer: {
      projectReducer: { selectedProject },
    },
  } = useSelector((state) => state);
  const dispatch = useDispatch();

  const parseData = useCallback((data) => {
    if (!data?.message || data.type === 'ping') {
      return;
    }
    console.log(`ws data:`, data);

    const { message } = data;

    message.data.forEach(obj => {
      if (obj.type === 'discussion_messages') {
        dispatch(setNewWSDiscussionMsg(obj.attributes))
      }

      if (obj.type === 'discussions') {
        // dispatch stuff related with discussions
        const { attributes } = obj;

        // discussion was created from project
        if (attributes.project_id?.length) {
          dispatch(setNewWSProjectDiscussion(attributes));
          return
        }

        // discussion was created from company
        if (attributes.company_id?.length) {
          return;
        }

        // discussion was created from event
        if (attributes.event_id?.length) {
          dispatch(setNewWSEventDiscussion(attributes));
          return;
        }

        dispatch(setNewWSDiscussion(attributes))
      }
    });
  }, [selectedProject])

  const openSocketChannels = useCallback((channel) => {
    const ws = new WebSocket(
      `${process.env.REACT_APP_WSS}/cable?access-token=${session?.accessToken}&uid=${session?.uid}&client=${session?.client}`
    );

    ws.onopen = () => {
      const msg = {
        command: "subscribe",
        council_id: selectedCouncil.id,
        identifier: JSON.stringify({
          channel,
          council_id: selectedCouncil.id,
          user_id: session.id,
        }),
      };

      ws.send(JSON.stringify(msg));
    };

    try {
      ws.onmessage = (event) => {
        const parsedData = JSON.parse(event.data);
        parseData(parsedData);
      };
      ws.onclose = (e) => {
        console.log('Socket is closed. Reconnect will be attempted in 5 second.', e.reason);
        const timeout = setTimeout(() => {
          openSocketChannels(channel);
          clearTimeout(timeout);
        }, 5000);
      };
      ws.onerror = (error) => {
        console.log("Error: " + JSON.stringify(error));
      };
    } catch (error) {
      console.log("Error catch: " + error);
    }

    return ws;
  }, [session])

  useEffect(() => {
    const tractionGenericSocket = openSocketChannels('SubscribeToTractionLiveUpdates');

    return () => {
      tractionGenericSocket.close();
    };
  }, []);

  return ''
};

export default React.memo(RootSocketProvider);
